import { memo } from 'react'
import { Stack, Subheader3, TextField, Tooltip } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import {
  getSelectedContent,
  getSelectedTenant,
  getSelectedUser,
} from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import TargetContentSearchInput from '../TargetContentSearchInput'
import TargetContentSearchResult from '../TargetContentSearchResult'
import SelectedContent from '../SelectedContent'

interface DestinationContentProps {
  contentSharingType: ContentSharingModelType
}

const DestinationContent: React.FC<DestinationContentProps> = ({ contentSharingType }) => {
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))
  const selectedUser = useSelector((state) => getSelectedUser(state, { contentSharingType }))
  const selectedTargetContent = useSelector((state) => getSelectedContent(state, { contentSharingType }))
  const isIgnoreContentOwner = selectedTenant?.IsSearchTargetContentByTenantEnabled
  const isMergeForReview = contentSharingType === ContentSharingModelType.MergeForReview
  const isMerge = contentSharingType === ContentSharingModelType.ContentsMerging || isMergeForReview

  const showTargetContentSearchInput = isIgnoreContentOwner ? selectedTenant?.Id && isMerge : selectedUser && isMerge
  if (!showTargetContentSearchInput) {
    return null
  }

  return (
    <Stack>
      <Subheader3>Session Destination</Subheader3>
      {selectedTargetContent?.IsPredefined ? (
        <Tooltip text={selectedTargetContent.Description}>
          <TextField value={selectedTargetContent.Description} disabled />
        </Tooltip>
      ) : (
        <Stack>
          <SelectedContent contentSharingType={contentSharingType} />
          {!selectedTargetContent && (
            <>
              <TargetContentSearchInput contentSharingType={contentSharingType} />
              <TargetContentSearchResult />
            </>
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default memo(DestinationContent)

